// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3m63u","productName":"Table_productName__1bV80"};